// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_kq-0";
export var discountCodeInput = "_kq-1";